import React from 'react';
import { TopTopics } from '../../../../features/topics/components/TopTopics';
import { coreService } from '../../../../services/core/core-service';

export const TopTopicsByTypeSection: React.FC<{
  filters: {
    from: string;
    to: string;
    accountIds?: string[];
    crmFilters?: Record<string, string[]>;
  };
  onTopicSelected: (topic: {
    id: string;
    name: string;
    description: string;
    type: string;
    custom: boolean;
    following: boolean;
  }) => unknown;
  onEventCountCalculated?: (count: number) => unknown;
  onAddTopic: (category: string) => void;
  onEditTopic: (
    topic: { id: string; name: string; description: string; custom: boolean; following: boolean },
    category: string,
  ) => unknown;
  onFollowTopic: (id: string) => void;
  onUnfollowTopic: (id: string) => void;
  onRemoveTopic: (id: string) => void;
  onArchiveTopic: (id: string) => void;
  onPinTopic: (id: string) => void;
  onDisableTopic: (id: string) => void;
}> = ({
  filters,
  onTopicSelected,
  onEventCountCalculated,
  onAddTopic,
  onEditTopic,
  onFollowTopic,
  onUnfollowTopic,
  onRemoveTopic,
  onArchiveTopic,
  onDisableTopic,
  onPinTopic,
}) => {
  return (
    <>
      <TopTopics
        id="top-risks"
        insightType="Risks"
        filters={filters}
        onTopicSelected={onTopicSelected}
        onEventCountCalculated={onEventCountCalculated}
        onAddTopic={onAddTopic}
        onEditTopic={topic => onEditTopic(topic, 'Risks')}
        onFollowTopic={onFollowTopic}
        onUnfollowTopic={onUnfollowTopic}
        onRemoveTopic={onRemoveTopic}
        onArchiveTopic={onArchiveTopic}
        onDisableTopic={onDisableTopic}
        onPinTopic={onPinTopic}
        topicsFetcher={coreService.getTopTopics.bind(coreService)}
      />

      <TopTopics
        id="top-product-feedback"
        insightType="Product Feedback"
        filters={filters}
        onTopicSelected={onTopicSelected}
        onEventCountCalculated={onEventCountCalculated}
        onAddTopic={onAddTopic}
        onEditTopic={topic => onEditTopic(topic, 'Product Feedback')}
        onFollowTopic={onFollowTopic}
        onUnfollowTopic={onUnfollowTopic}
        onRemoveTopic={onRemoveTopic}
        onArchiveTopic={onArchiveTopic}
        onDisableTopic={onDisableTopic}
        onPinTopic={onPinTopic}
        topicsFetcher={coreService.getTopTopics.bind(coreService)}
      />

      <TopTopics
        id="top-advocacy"
        insightType="Advocacy"
        filters={filters}
        onTopicSelected={onTopicSelected}
        onEventCountCalculated={onEventCountCalculated}
        onAddTopic={onAddTopic}
        onEditTopic={topic => onEditTopic(topic, 'Advocacy')}
        onFollowTopic={onFollowTopic}
        onUnfollowTopic={onUnfollowTopic}
        onRemoveTopic={onRemoveTopic}
        onArchiveTopic={onArchiveTopic}
        onDisableTopic={onDisableTopic}
        onPinTopic={onPinTopic}
        topicsFetcher={coreService.getTopTopics.bind(coreService)}
      />

      <TopTopics
        id="top-growth-opportunities"
        insightType="Growth Opportunities"
        filters={filters}
        onTopicSelected={onTopicSelected}
        onEventCountCalculated={onEventCountCalculated}
        onAddTopic={onAddTopic}
        onEditTopic={topic => onEditTopic(topic, 'Growth Opportunities')}
        onFollowTopic={onFollowTopic}
        onUnfollowTopic={onUnfollowTopic}
        onRemoveTopic={onRemoveTopic}
        onArchiveTopic={onArchiveTopic}
        onDisableTopic={onDisableTopic}
        onPinTopic={onPinTopic}
        topicsFetcher={coreService.getTopTopics.bind(coreService)}
      />
    </>
  );
};
